import { render, staticRenderFns } from "./OrderSelectLang.vue?vue&type=template&id=157783e4&"
import script from "./OrderSelectLang.vue?vue&type=script&lang=js&"
export * from "./OrderSelectLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports